import axiosInstance from '@/services/axiosInstance'
import mock from '@/services/mock/index'
import store from '@/store'

async function companies (order = {}, params = null) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(mock.getLanguages.data)
      }, 500)
    })
  } else {
    const headers = store.getters['auth/httpQueryHeaders']
    const req = {
      url: '/api/cifsempresa/getcifspag',
      method: 'POST',
      headers: headers,
      data: order,
      params
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { companies }
